import React, { useEffect, useState } from "react";
import classes from "./ThreeWayMatching.module.css";
import axios from "axios";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import ThreeWayMatchTable from "../ThreeWayMatching/purchaseorder";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import { Autocomplete } from "@mui/material";
import ItemVendorMap from "./ItemVendorMap";
import VendorItemTable from "../ThreeWayMatching/VendorTable";
import Header from "../../../components/Home/Header/Header";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import InvoiceChart from "./Charts/InvoiceCharts";
import VendorChart from "./Charts/VendorOnboardChart";
import VendorStatusPie from "./Charts/StatusPie";
import VendorOnboardChart from "./Charts/VendorOnboardDateChart";
import VendorInvoiceDashboard from "./Charts/VendorInvoiceDash";
import VendorInvoiceTable from "./Charts/VendorInvoiceTable";
import InvoiceStatusTable from "./Charts/InvoiceStatusTable";
import PendingESignatureTable from "./Charts/EsignStatus";
import CountCards from "./Charts/CountCards";
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";

const InvoiceAutomation = () => {
  const location = useLocation();
  const loginData = useSelector((state) => state.loginData.value);

  const [selectedFile, setSelectedFile] = useState(null);
  const [invoiceList, setInvoiceList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [invoicepage, setInvoicePage] = useState(false);

  const [userStatus, setUserStatus] = useState({});
  const [exporting, setExporting] = useState(false);
  const pdfRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setInvoiceList([]);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        API_ENDPOINT.invoice_generate,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            // optional: show file upload progress
          },
        }
      );

      const invoices = response.data.invoices;

      // Simulate row-wise status updates
      let progressMap = {};
      for (let i = 0; i < invoices.length; i++) {
        const invoice = invoices[i];

        progressMap[invoice.vendor.email] = `Generating... ${Math.round(
          ((i + 1) / invoices.length) * 100
        )}%`;
        setUserStatus({ ...progressMap });

        await new Promise((resolve) => setTimeout(resolve, 300)); // simulate delay

        progressMap[invoice.vendor.email] = "✅ Done!";
        setUserStatus({ ...progressMap });
      }

      setInvoiceList(invoices);
    } catch (error) {
      console.error("Upload failed", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = (invoice) => {
    const byteChars = atob(invoice.pdf_base64);
    const byteArray = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteArray[i] = byteChars.charCodeAt(i);
    }

    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = invoice.filename || "Invoice.pdf";
    a.click();
    URL.revokeObjectURL(url);
  };

  const switchInvoice = () => {
    setInvoicePage((prev) => !prev);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const action = params.get("action");
    if (action === "create") {
      setInvoicePage(true);
    }

    if (action === "download") {
      downloadScreenAsPDF();
    }
  }, [location.search]);

  const downloadScreenAsPDF = async () => {
    try {
      setExporting(true);
      document.body.classList.add("exporting");

      window.scrollTo(0, 0);
      await new Promise((r) => setTimeout(r, 1000));

      const element = pdfRef.current;

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgHeight = (canvas.height * pageWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("Merchant-Invoice-Dashboard.pdf");
    } catch (err) {
      console.error("PDF export failed", err);
    } finally {
      document.body.classList.remove("exporting");
      setExporting(false);
    }
  };

  return (
    <div ref={pdfRef} style={{ margin: "1rem" }}>
      <div className={classes.headerContainer}>
        <HeaderTitle titleText={"Merchant Invoice Dashboard"} />

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={downloadScreenAsPDF}
            className={classes.invoiceBtn}
            disabled={exporting}
          >
            {exporting ? "Exporting..." : "Export Data"}
          </button>

          {loginData.access_type !== "Buyer" && (
            <button onClick={switchInvoice} className={classes.invoiceBtn}>
              {!invoicepage ? "Create Invoice" : "Back"}
            </button>
          )}
        </div>
      </div>

      {/* <div className={classes.container}>
                <button onClick={() => switchInvoice()} className={classes.invoiceBtn}>Create invoice</button>
                
            </div> */}

      <div>
        {invoicepage ? (
          <div style={{ padding: 24, fontSize: "14px", fontWeight: "500" }}>
            <h2>Merchant Invoice Auto-Generation(upload Excel/CSV file)</h2>

            <div
              style={{
                background: "#f0f4f8",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "600px",
                marginBottom: "20px",
              }}
            >
              <label
                style={{
                  display: "inline-block",
                  padding: "10px 16px",
                  backgroundColor: "#cdddf6",
                  borderRadius: 6,
                  cursor: "pointer",
                  marginBottom: 12,
                  fontSize: "14px",
                }}
              >
                Select Excel/CSV File
                <input
                  type="file"
                  accept=".csv,.xlsx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </label>

              {selectedFile && <p>Selected: {selectedFile.name}</p>}

              {selectedFile && (
                <button
                  onClick={handleUpload}
                  style={{
                    marginTop: 10,
                    padding: "8px 16px",
                    backgroundColor: "#3f51b5",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  {loading ? "Generating..." : "Generate Invoices"}
                </button>
              )}
            </div>

            <div>
              {Object.keys(userStatus).length > 0 && (
                <div style={{ marginTop: 20, fontSize: "14px" }}>
                  <strong>Status:</strong>
                  <ul style={{ marginTop: 10 }}>
                    {Object.entries(userStatus).map(([email, status], i) => (
                      <li key={i} style={{ marginBottom: 4 }}>
                        <strong>{email}</strong>: {status}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {invoiceList.length > 0 && (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                  background: "#fff",
                  maxWidth: "800px",
                }}
              >
                <thead style={{ backgroundColor: "#dde8f3" }}>
                  <tr>
                    <th style={{ padding: 10, border: "1px solid #ccc" }}>
                      Merchant Code/ Vendor Code
                    </th>
                    <th style={{ padding: 10, border: "1px solid #ccc" }}>
                      Mechant Name/ Vendor Name
                    </th>
                    <th style={{ padding: 10, border: "1px solid #ccc" }}>
                      Email
                    </th>
                    <th style={{ padding: 10, border: "1px solid #ccc" }}>
                      Transaction Amount
                    </th>
                    <th style={{ padding: 10, border: "1px solid #ccc" }}>
                      Invoice
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceList.map((invoice, index) => (
                    <tr key={index}>
                      <td style={{ padding: 10, border: "1px solid #ccc" }}>
                        {invoice?.invoice_id}
                      </td>
                      <td style={{ padding: 10, border: "1px solid #ccc" }}>
                        {invoice.vendor?.company_name}
                      </td>
                      <td style={{ padding: 10, border: "1px solid #ccc" }}>
                        {invoice.vendor?.email}
                      </td>
                      <td style={{ padding: 10, border: "1px solid #ccc" }}>
                        ₹{invoice.vendor?.amount}
                      </td>
                      <td
                        style={{
                          padding: 10,
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        <button
                          onClick={() => downloadPDF(invoice)}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          title="Download PDF"
                        >
                          📄
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: "1rem" }}>
              <CountCards />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ flex: 1 }}>
                <InvoiceChart />
              </div>
              <div style={{ flex: 1 }}>
                <VendorChart />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ flex: 1 }}>
                <VendorStatusPie />
              </div>
              <div style={{ flex: 1 }}>
                <VendorOnboardChart />
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <div style={{ flex: 1 }}>
                <VendorInvoiceDashboard />
              </div>
              {/* <div style={{ flex: 1 }}>
                                <VendorOnboardChart />
                            </div> */}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ flex: 1 }}>
                <VendorInvoiceTable />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ flex: 1 }}>
                <InvoiceStatusTable />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ flex: 1 }}>
                <PendingESignatureTable />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceAutomation;
